import { render, staticRenderFns } from "./pos-MostSales.vue?vue&type=template&id=6f575278"
import script from "./pos-MostSales.vue?vue&type=script&lang=js"
export * from "./pos-MostSales.vue?vue&type=script&lang=js"
import style0 from "./pos-MostSales.vue?vue&type=style&index=0&id=6f575278&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports